import { gql, TypedDocumentNode } from "@apollo/client";

import {
  AwsScanSettings,
  QueryScanArgs,
  Scan,
  ScanProviderConfig,
  ScanScope,
  Space,
} from "types/generated";

export type ScanSettingsItem = Pick<
  Scan,
  "id" | "name" | "description" | "labels" | "workerPool" | "workerPoolName"
> & {
  space: Pick<Space, "id" | "name">;
  providerConfigs: Array<
    Pick<ScanProviderConfig, "type" | "version" | "integration" | "integrationName"> & {
      config: Pick<AwsScanSettings, "region">;
    }
  >;
  scope: Array<Pick<ScanScope, "type">>;
};

export const GET_SCAN_SETTINGS: TypedDocumentNode<{ scan: ScanSettingsItem }, QueryScanArgs> = gql`
  query GetScanSettings($id: ID!) {
    scan(id: $id) {
      id
      name
      description
      labels
      workerPool
      workerPoolName
      space {
        id
        name
      }
      providerConfigs {
        type
        version
        integration
        integrationName
        config {
          ... on AWSScanSettings {
            region
          }
        }
      }
      scope {
        type
      }
    }
  }
`;
